import { createRouter, createWebHistory } from 'vue-router'
import { allRoute } from '@/router/routes'
import { hasPermission, hasRole } from '@/helpers/permissions'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { useAuthStore } from '@/stores/auth'
import { hasToken } from '@/helpers/auth-token'

NProgress.configure({ showSpinner: false })

// Reset hook called on logout. Kept as a stable export so the auth store can
// clear any one-time session-verification state when a real heartbeat is added.
// Reset hook called on logout. Kept as a stable export so the auth store can
// clear any one-time session-verification state when a real heartbeat is added.
export const resetTokenCheck = () => {
  // no-op for the static scaffold
}
  // no-op for the static scaffold


const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: allRoute,
})

router.beforeEach((to, from, next) => {
  NProgress.start()

  if (to.meta.title) {
    document.title = to.meta.title.toString()
  }

  const authRequired = to.matched.some((route) => route.meta.authRequired)
  if (authRequired) {
    const authStore = useAuthStore()
    if (!hasToken() || !authStore.isAuthenticated()) {
      return next({ name: 'auth.sign-in', query: { redirectedFrom: to.fullPath } })
    }
  }

  const requiredPermission = to.meta.permission as string | undefined
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return next({ name: 'error.403' })
  }
  next()
})

router.afterEach(() => {
  NProgress.done()
})

export default router
